const { getNumericValueWithDecimals } = require('../../analyticUtils');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const {
  createEcommerceEventItemsGA4,
} = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { GA4 } = require('../../../../../../config/analytics');
const { cartItemListStorage } = require('../../stores/itemList');
const { searchDataOfCartItemsStorage } = require('../../stores/searchData');

/* -------------------------------------------------------------------------- *\
 * CART EVENTS                                                                *
 * -----------                                                                *
 * - Coupon applied error code                                                *
 * - Add product                                                              *
 * - Remove product                                                           *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Coupon applied error code
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.couponAppliedErrorCode,
    (errorCode) => {
      pushEvent(
        createCustomEventGA4('discount_code_error', [['message', errorCode]])
      );
    }
  );

  // Add product
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productAddedToCart,
    /**
     * Handle productAddedToCart event
     * @param {Object} payload The payload of the event
     * @param {Cart} payload.cart - The cart
     * @param {string} payload.context Section from which the product was added to cart
     * @param {string} payload.doubleLookPID The ID of the double look product
     * used to add to cart (ex: '241BZ0439.10000_DL137')
     * @param {string} [payload.list] The list type of the event
     * @param {number} [payload.position] The position of the product (zero-based)
     * @param {Types.FullProduct} payload.product The full product data
     * @param {ProductLineItem} payload.productLineItem The product line item
     * corresponding to the added product
     */
    (payload) => {
      pushEvent(
        createEcommerceEventGA4(
          'add_to_cart',
          createEcommerceEventItemsGA4(
            [
              {
                ...payload.product,
                doubleLookPID: payload.doubleLookPID,
                itemProps: {
                  add_to_cart_place: payload.context || GA4.PAGE_TYPES.product,
                },
              },
            ],
            {
              getItemListStorageKey: (product) => product.id,
              itemListStorage: cartItemListStorage,
              targetSearchDataStorage: searchDataOfCartItemsStorage,
            }
          ),
          {
            currency: gaInfo.currencyCode,
            value: getNumericValueWithDecimals(
              payload.product?.price?.sales?.decimalPrice
            ),
          }
        )
      );
    }
  );

  // Remove product
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productRemovedFromCart,
    (payload) => {
      pushEvent(
        createEcommerceEventGA4(
          'remove_from_cart',
          createEcommerceEventItemsGA4([payload.product], {
            getItemListStorageKey: (product) => product.id,
            itemListStorage: cartItemListStorage,
            targetSearchDataStorage: searchDataOfCartItemsStorage,
          }),
          {
            currency: gaInfo.currencyCode,
            value: getNumericValueWithDecimals(
              payload.product?.price?.sales?.decimalPrice
            ),
          }
        )
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
